import { Controller } from "react-hook-form";
import FIlterSelect from "../filter-select";
import Input from "../input";
import useRequest from "../hooks/use-request";
import { useEffect, useState } from "react";
import MultiFIlterSelect from "../multi-filter-select";

interface Details {
  control: any;
  clearErrors: any;
  errors: any;
  requisition: any;
}

interface SourcingOfficer {
  _id: {
    _id: string;
    username: string;
  };
  username: string;
  quantity: number;
  unitPrice: number;
  subTotal: number;
  
}

interface Region {
  _id: string;
  regionName: string;
  sourcingOfficers: SourcingOfficer[];
}

const RequisitionInformation: React.FC<Details> = ({ control, requisition }) => {
  const [regions, setRegions] = useState<Region[]>([]);
  const [selectedRegion, setSelectedRegion] = useState<Region | null>(null);
  const userToken = localStorage.getItem("token");

  const { makeRequest: getPromotions } = useRequest("/region", "GET", {
    Authorization: `Bearer ${userToken}`,
  });

  useEffect(() => {
    const fetchSuppliers = async () => {
      const [response] = await getPromotions();
      if (response.status) {
        setRegions(response.data?.regions || []);
      }
    };
    fetchSuppliers();
  }, []);

  return (
    <div className="flex flex-col gap-5">
      {/* Sourcing Region */}
      <div className="items-center gap-4">
        <Controller
          name="regionName"
          defaultValue={requisition?.regionName}
          control={control}
          rules={{
            required: "Region is required",
          }}
          render={({ field, fieldState }) => (
            <FIlterSelect
              name="regionName"
              options={regions.map((region) => ({
                value: region._id,
                label: region.regionName,
              }))}
              className="w-full"
              label="Sourcing Region"
              placeholder="Select Sourcing Region"
              onChange={(selectedValue) => {
                field.onChange(selectedValue);
                const foundRegion = regions.find((region) => region._id === selectedValue);
                setSelectedRegion(foundRegion || null);
              }}
              error={fieldState?.error?.message}
              value={field.value}
            />
          )}
        />
      </div>

      {/* Sourcing Officers */}
      <div className="items-center gap-4">
        <Controller
          name="sourcingOfficers"
          defaultValue={requisition?.sourcingOfficers}
          control={control}
          rules={{
            required: "Sourcing Officer is required",
          }}
          render={({ field, fieldState }) => (
            <MultiFIlterSelect
              name="sourcingOfficers"
              options={(selectedRegion?.sourcingOfficers || []).map(officer => ({
                value: officer._id._id, // Use the nested _id string
                label: officer.username,
              }))}
              className="w-full"
              label="Sourcing Officer"
              placeholder="Select Sourcing Officers"
              onChange={(selectedValue) => {
                field.onChange(selectedValue);
              }}
              error={fieldState?.error?.message}
              value={field.value}
               // Optional: disable field if no region selected
            />
          )}
        />
      </div>

      {/* Urgency Level */}
      <div className="items-center gap-4">
        <Controller
          name="urgencyLevel"
          defaultValue={requisition?.urgencyLevel}
          control={control}
          rules={{
            required: "Urgency is required",
          }}
          render={({ field, fieldState }) => (
            <FIlterSelect
              name="urgencyLevel"
              options={[
                { value: "low", label: "Low" },
                { value: "medium", label: "Medium" },
                { value: "high", label: "High" },
                
              ]}
              className="w-full"
              label="Urgency Level"
              placeholder="Select Urgency Level"
              onChange={(selectedValue) => {
                field.onChange(selectedValue);
              }}
              value={field.value}
              error={fieldState?.error?.message}
            />
          )}
        />
      </div>

      {/* Date Required */}
      <div className="items-center gap-4">
        <Controller
          name="dateRequired"
          defaultValue={requisition?.dateRequired}
          control={control}
          rules={{
            required: "Date is required",
          }}
          render={({ field, fieldState }) => (
            <Input
              value={field.value}
              type="date"
              className="w-full"
              label="Date"
              placeholder="Enter Date"
              error={fieldState?.error?.message}
              onChange={field.onChange}
            />
          )}
        />
      </div>
    </div>
  );
};

export default RequisitionInformation;
